import { ConditionEvaluatorInterface, ParsedCondition } from "../types";

export class ElapsedTimeEvaluator implements ConditionEvaluatorInterface {
  readonly type = "elapsed" as const;
  private timeoutIds: Set<ReturnType<typeof setTimeout>> = new Set();

  watch(condition: ParsedCondition, callback: () => void): () => void {
    const ms = this.parseToMilliseconds(condition);
    if (ms === null) {
      console.warn(`Invalid elapsed time condition: ${condition.value}${condition.unit || ""}`);
      return () => {};
    }

    const timeoutId = setTimeout(() => {
      this.timeoutIds.delete(timeoutId);
      callback();
    }, ms);

    this.timeoutIds.add(timeoutId);

    return () => {
      clearTimeout(timeoutId);
      this.timeoutIds.delete(timeoutId);
    };
  }

  dispose(): void {
    this.timeoutIds.forEach((id) => {
      clearTimeout(id);
    });
    this.timeoutIds.clear();
  }

  private parseToMilliseconds(condition: ParsedCondition): number | null {
    const value = parseFloat(condition.value);
    if (Number.isNaN(value) || value < 0) {
      return null;
    }

    const unit = condition.unit?.toLowerCase() || "s";

    switch (unit) {
      case "s":
        return value * 1000;
      case "m":
        return value * 60 * 1000;
      case "ms":
        return value;
      default:
        return null;
    }
  }
}
